const reusableLineGraphConfig = {
  graphLegendYearIndication: true,
  dataKeys: [
    {
      title: 'Principal',
      dataKey: 'principal',
    },
    {
      title: 'Interest',
      dataKey: 'interest'
    },
    {
      title: 'Remaining',
      dataKey: 'remaining'
    }
  ],
  periodsKey: 'year',
}

export default reusableLineGraphConfig;
